import dynamic from 'next/dynamic';

// eslint-disable-next-line import/prefer-default-export
export const Tour = dynamic(() => import('reactour'), { ssr: false });
